export enum FORMS_ACLs {
  FORMS_UPLOAD_MANAGE = 415,
  FORMS_PROVIDER_REVIEW_MANAGE = 901,
  FORMS_PROVIDER_REVIEW = 902,
  FORMS_CLONE_MANAGE = 903,
}
